import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Málaga"
      slug="malaga"
      poblacion={597173}
      lat={36.7213}
      lng={-4.4214}
      serviceSlug="malaga"
      neighborhoodsText="Cubrimos toda Málaga capital: Centro Histórico, Pedregalejo, El Palo, Teatinos, Carretera de Cádiz, Ciudad Jardín, Churriana y Campanillas. Nuestro taller está en San Andrés."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Málaga?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Málaga?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}